import React, { useContext } from "react";
import { Header } from "../../Components/Header";
import RouteConfig from "../../Routes/RouteConfig";
import { Box } from "@mui/material";
import { UserContext, UserContextType } from "../../Context/UserContext";
import ErrorBoundary from '../../Routes/ErrorBoundary';
import { ToastInitializer } from '../../Components/Toast/ToastInitializer';

const RootApp = () => {
  const { user } = useContext<UserContextType>(UserContext);
  return (
    <Box display={"flex"} flexDirection={"column"} height={"100%"}>
      <ToastInitializer />
      {user ? <Header isBreadcrumb={true} isSearch={true} /> : ""}
      <ErrorBoundary>
        <RouteConfig />
      </ErrorBoundary>
    </Box>
  );
};

export default RootApp;
